import { render, staticRenderFns } from "./MyOwnProfile.vue?vue&type=template&id=fadcb174&scoped=true&"
import script from "./MyOwnProfile.vue?vue&type=script&lang=js&"
export * from "./MyOwnProfile.vue?vue&type=script&lang=js&"
import style0 from "./MyOwnProfile.vue?vue&type=style&index=0&id=fadcb174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadcb174",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VForm,VImg,VTextField})
